import { useCallback, useState } from 'react'

import { useIsTrialAccount } from '@/modules/account'
import { useTrialTourSeen } from './useTrialTourSeen'

// The tour runs once per trial user. A preview (#celebrate on the case URL) runs it every time.
export const useTrialTour = (isPreview: boolean) => {
  const isTrial = useIsTrialAccount()
  const { seen, markSeen } = useTrialTourSeen()
  const [isRunning, setIsRunning] = useState(false)

  const start = useCallback(() => {
    if (!isPreview && (!isTrial || seen)) return
    // Saved as seen when it starts, so leaving the case or closing the tab midway still counts.
    markSeen()
    setIsRunning(true)
  }, [isPreview, isTrial, seen, markSeen])

  const end = useCallback(() => setIsRunning(false), [])

  return { isRunning, start, end }
}
